import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LegalDocumentAudienceEnum, LegalDocumentTypeEnum } from '@hrra/common-models';
import { SmartHttpService } from './smart-http.service';

@Injectable({
  providedIn: 'root',
})
export class LegalDocumentService {
  constructor(private smartHttp: SmartHttpService) {}

  /**
   * Loads static legal document html from assets/legal and replaces {key} placeholders with values from params.
   * File naming: {type}-{audience}-{providerWebsiteId}.{language}.html
   */
  public getLegalDocument(
    type: LegalDocumentTypeEnum,
    audience: LegalDocumentAudienceEnum,
    providerWebsiteId: number,
    language: string,
    params: { [key: string]: string } = {}
  ): Observable<string> {
    return this.smartHttp
      .getHtml(`/assets/legal/${type}-${audience}-${providerWebsiteId}.${language}.html`)
      .pipe(map((response) => response.data.replace(/{(\w+)}/g, (match, key) => (key in params ? params[key] ?? '' : match))));
  }
}
